import React from 'react';
import PropTypes from 'prop-types';
import { PlayerProvider } from 'containers/Player/context/PlayerContext';
import { BootstrapConsumer } from './BootstrapContext';
import { CombinedContextProvider } from './CombinedContext';
import { UserProvider, UserConsumer } from '../providers/user.provider';
import BootstrapProvider from './BootstrapProvider';

class CombinedProvider extends React.PureComponent {
  render() {
    return (
      <BootstrapProvider>
        <UserProvider>
          <BootstrapConsumer>
            {bootstrapContext => (
              <UserConsumer>
                {userContext => (
                  <CombinedContextProvider
                    value={{ ...bootstrapContext, ...userContext }}
                  >
                    <PlayerProvider>{this.props.children}</PlayerProvider>
                  </CombinedContextProvider>
                )}
              </UserConsumer>
            )}
          </BootstrapConsumer>
        </UserProvider>
      </BootstrapProvider>
    );
  }
}

CombinedProvider.propTypes = {
  children: PropTypes.node,
};

export default CombinedProvider;
